<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 background-white overflow-x-hidden overflow-y-auto fix-overflow-scroll no-scroll-bar">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="row m-0 p-2 background-primary-blue height-70px shadow z-max align-items-center">
        <div (click)="back()" class="col-2 pt-4 pb-4 btn text-reset d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-chevron-left fa-xl"></i>
        </div>
        <div class="col-8 m-auto">
            <app-spinner [loading]="loading"></app-spinner>
            @if (!loading) {
                <div class="fs-main text-center color-white">Edit {{ animals.length }} animals</div>
            }
        </div>
        <div (click)="close()" class="pointer text-reset col-2 d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-x fa-xl"></i>
        </div>
    </div>
    <div class="d-flex flex-column p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
        @if (!loading) {
            <div class="mb-3">
                <div class="row">
                    <div class="">Assigned paddock</div>
                </div>
                <div class="row mb-3">
                    <div class="col dropdown">
                        <button aria-controls="editAssignedPaddockCollapse"
                                class="btn btn-info btn-info-shadow dropdown-toggle w-100"
                                data-bs-target="#editAssignedPaddockCollapse"
                                data-bs-toggle="collapse"
                                type="button">
                            {{ selectedPaddock?.name || "Select" }}
                        </button>
                        <div class="collapse"
                            id="editAssignedPaddockCollapse">
                            @for (paddock of paddocks; track paddock.id) {
                                <div>
                                    <div (click)="setPaddock(paddock)" aria-controls="editAssignedPaddockCollapse"
                                        class="btn card m-1"
                                        data-bs-target="#editAssignedPaddockCollapse"
                                        data-bs-toggle="collapse">{{ paddock.name }}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">Animal type</div>
                    <div class="col">Year born</div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <button aria-controls="editAnimalTypeCollapse"
                                aria-expanded="false"
                                class="btn btn-info btn-info-shadow dropdown-toggle w-100"
                                data-bs-target="#editAnimalTypeCollapse"
                                data-bs-toggle="collapse"
                                type="button">
                            {{ selectedAnimalType || "Select" | toCapitalizedText }}
                        </button>
                        <div class="collapse"
                            id="editAnimalTypeCollapse">
                            @for (animalType of animalTypes; track animalType) {
                                <div>
                                    <div (click)="setAnimalType(animalType)"
                                        aria-controls="editAnimalTypeCollapse" class="btn card m-1"
                                        data-bs-target="#editAnimalTypeCollapse"
                                        data-bs-toggle="collapse">{{ animalType | toCapitalizedText }}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div class="col dropdown">
                        <button aria-controls="editYobCollapse"
                                aria-expanded="false"
                                class="btn btn-info btn-info-shadow dropdown-toggle w-100"
                                data-bs-target="#editYobCollapse"
                                data-bs-toggle="collapse"
                                id="yobDropdownMenuButton"
                                type="button">
                            {{ selectedYear || "Select" }}
                        </button>
                        <div class="collapse"
                            id="editYobCollapse">
                            @for (year of years; track year) {
                                <div>
                                    <div (click)="setYob(year)"
                                        aria-controls="editYobCollapse"
                                        class="btn card m-1"
                                        data-bs-target="#editYobCollapse"
                                        data-bs-toggle="collapse">{{ year }}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <app-generic-button
                    (click)="applyChanges()"
                    description="Apply changes to animals"
                    [alwaysShowText]="true"
                    [buttonText]="'Apply'"
                    [disabled]="loading || (selectedYear == undefined && selectedPaddock == undefined && selectedAnimalType == undefined)"
                    [loading]="loading"
                    [primaryIcon]="'fa-solid fa-check'"/>
            </div>
        }
        <hr/>
        <div class="d-flex flex-column gap-2">
            @for (animal of animals; track animal.id) {
                <app-animal-button [id]="animal.id"
                                    [clickable]="false"
                                    [selectableForAlteration]="false"
                                    [selectableForDeletion]="false"
                                    [standalone]="true"/>
            }
        </div>
        <app-spinner [loading]="loading"></app-spinner>
    </div>
</div>
